export default __webpack_public_path__ + "static/mobile-16a48acac127765ce9cab14c15920881.webp";